"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Contract = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const TableauError_1 = require("../TableauError");
class SheetUtils {
    // This is a direct port from SheetSize.cs - SheetSizeFactory
    static getSheetSizeFromSizeConstraints(sizeConstraint) {
        const { minWidth, minHeight, maxWidth, maxHeight } = sizeConstraint;
        if (minHeight === 0 && minWidth === 0) {
            if (maxHeight === 0 && maxWidth === 0) {
                return {
                    behavior: Contract.SheetSizeBehavior.Automatic,
                };
            }
            return {
                behavior: Contract.SheetSizeBehavior.AtMost,
                maxSize: { width: maxWidth, height: maxHeight },
            };
        }
        if (maxHeight === 0 && maxWidth === 0) {
            return {
                behavior: Contract.SheetSizeBehavior.AtLeast,
                minSize: { width: minWidth, height: minHeight },
            };
        }
        if (maxHeight === minHeight && maxWidth === minWidth && minWidth > 0) {
            return {
                behavior: Contract.SheetSizeBehavior.Exactly,
                minSize: { width: minWidth, height: minHeight },
                maxSize: { width: minWidth, height: minHeight },
            };
        }
        // 'Fit Width' for a DSD layout
        const isDsdLayout = minWidth === 0 && maxWidth === 0;
        return {
            behavior: Contract.SheetSizeBehavior.Range,
            minSize: { width: minWidth, height: minHeight },
            maxSize: { width: isDsdLayout ? 2147483647 : maxWidth, height: maxHeight },
        };
    }
    static createAutomaticSize() {
        let behavior = Contract.SheetSizeBehavior.Automatic;
        let minSize = { width: 0, height: 0 };
        let maxSize = { width: 0, height: 0 };
        return { behavior, minSize, maxSize };
    }
    static getPublishedSheetInfoByName(name, sheetInfos) {
        const sheetInfo = sheetInfos.find((sheet) => sheet.name === name);
        return sheetInfo;
    }
    static getSheetTypeEnum(internalSheetType) {
        let sheetType;
        switch (internalSheetType) {
            case api_internal_contract_js_1.SheetType.Worksheet: {
                sheetType = Contract.SheetType.Worksheet;
                break;
            }
            case api_internal_contract_js_1.SheetType.Dashboard: {
                sheetType = Contract.SheetType.Dashboard;
                break;
            }
            case api_internal_contract_js_1.SheetType.Story: {
                sheetType = Contract.SheetType.Story;
                break;
            }
            default: {
                throw new TableauError_1.TableauError(Contract.SharedErrorCodes.ServerError, 'Invalid SheetType');
            }
        }
        return sheetType;
    }
    static isValidSheetSize(sizeObject) {
        return sizeObject.behavior !== undefined;
    }
}
exports.SheetUtils = SheetUtils;
//# sourceMappingURL=SheetUtils.js.map